// extracted by mini-css-extract-plugin
export var scrollArea = "_oc-0";